<template>
  <label class="flex items-center cursor-pointer">
    <input
      v-model="model"
      type="checkbox"
      class="sr-only peer"
    >
    <span class="relative w-9 h-5 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-secondary-emphatic/40 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-secondary" />
    <span class="ms-3 text-sm font-medium text-gray-700">{{ text }}</span>
  </label>
</template>

<script setup>

defineProps({
  text: {
    type: String,
    default: '',
  },
});

const model = defineModel();

</script>
